import { site } from "@/mocks/site-data";

export default function FloatingWhatsApp() {
  return (
    <a
      href={site.whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Conversar pelo WhatsApp"
      className="fixed bottom-20 right-4 z-40 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-[0_8px_24px_rgba(37,211,102,0.35)] transition-transform duration-300 hover:scale-105 md:bottom-6 md:right-6"
    >
      <i className="ri-whatsapp-line text-2xl" />
    </a>
  );
}